export default {
    businessList: state => state.businessList,
    selectedBusiness: state => state.selectedBusiness,
    activeBusinessBranding: state => state.activeBusinessBranding
}
